import { z } from 'zod';

export const formSchema = z.object({
    name: z.string({ required_error: 'Nome do perfil é obrigatório' }),
    description: z.string({
        required_error: 'Descrição do perfil é obrigatório',
    }),
    actions: z.number().array(),
});
